import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class PowerRankingDeleted extends DomainEvent<DeletedEntity> {}
